export default __webpack_public_path__ + "static/media/post-slice.8babe6b0.svg";